/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-06 17:44:43
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/LongCanvas/index.tsx
 */
/**
 *  Long Canvas
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';
import css from './css.less';

import LinkImgDraggableDisplay from '@/src/components/LinkImgDraggableDisplay';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const LongCanvas = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,

    onItemDelete,
    onItemAdd,
    onItemChange,
    onItemSort,

    //To Do Delete Link Temp
    linkSet,

    linkModules,
    specificError,
    disabled,
    hideEdit,
  } = props;

  const handleItemOnChange = (index, obj) => {
    if (onItemChange) {
      onItemChange(index, obj);
    }
  };

  const handleItemOnSort = (from, to) => {
    if (onItemSort) {
      onItemSort(from, to);
    }
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const handleItemOnAdd = (e) => {
    if (onItemAdd) {
      onItemAdd();
    }
  };

  return (
    <React.Fragment>
      <Section bottomBorder className={css.tipContainer}>
        <span className={css.tip}>{getI18n('general.addmultipleimages')}</span>
      </Section>
      <LinkImgDraggableDisplay
        error={specificError}
        linkSet={linkSet}
        droppableId={droppableId || 'CarouselDropZone'}
        data={linkModules}
        addText={`+ ${getI18n('general.addImageLink')}`}
        onAdd={handleItemOnAdd}
        onChange={handleItemOnChange}
        onSort={handleItemOnSort}
        {...(linkModules.length > 1 ? { onDelete: handleOnItemDelete } : {})}
        hideAdd={disabled}
        disabled={disabled}
        hideEdit={hideEdit}
      />
    </React.Fragment>
  );
};
export default LongCanvas;
